type Props = {
  progress: number;
  classes?: string;
};

const index = ({ progress = 0, classes = '' }: Props) => {
  return (
    <div className="h-8 w-full overflow-hidden rounded-16 bg-black-25">
      <div
        className={`h-full rounded-full bg-red-100 transition-width ${classes}`}
        style={{
          maxWidth: '100%',
          width: `${progress}%`,
        }}
      ></div>
    </div>
  );
};
export default index;
